import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios = initAxiosRH()
const PROMOTION = "promotion"
const PROMOTION_FILE_TYPE = `${PROMOTION}/file_type`
const PROMOTION_DETAILS_FILE = (id) => `${PROMOTION}/details/${id}/file`

export const promotionFileTypeGet = (params) => {
	const controller = loadAbort()
	const call = axios.get(PROMOTION_FILE_TYPE, { params, signal: controller.signal })
	return { call, controller }
}
export const promotionIdPut = (id, data, params) => {
    const controller = loadAbort()
    const call = axios.put(`${PROMOTION}/${id}`, data, { params, signal: controller.signal })
    return { call, controller }
}


// Details Files

export const promotionDetailsIdFileGet = ({ id, params }) => {
    const controller = loadAbort()
	const call = axios.get(PROMOTION_DETAILS_FILE(id), { params, signal: controller.signal })
	return { call, controller }
}
export const promotionDetailsIdFilePost = (id, data, params) => {
    const controller = loadAbort()
	const call = axios.post(PROMOTION_DETAILS_FILE(id), data, { params, signal: controller.signal })
	return { call, controller }
}
export const promotionDetailsIdFileIdGet = ({ id,fileId, params }) => {
    const controller = loadAbort()
    const call = axios.get(`${PROMOTION_DETAILS_FILE(id)}/${fileId}`, { params, signal: controller.signal })
    return { call, controller }
}
export const promotionDetailsIdFileIdDelete = ({ id,fileId, params }) => {
    const controller = loadAbort()
    const call = axios.delete(`${PROMOTION_DETAILS_FILE(id)}/${fileId}`, { params, signal: controller.signal })
    return { call, controller }
}

